import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import BrandLogo from '@/components/brand/BrandLogo';
import { BRAND } from '@/theme/brand';

const AtithiFooter = () => (
  <footer id="contact" className="section-outer text-white font-body bg-[#0D1B3E]">
    <div className="w-full overflow-hidden leading-none -mt-1">
      <svg
        viewBox="0 0 1440 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full block"
        preserveAspectRatio="none"
        style={{ height: '40px' }}
        aria-hidden
      >
        <path
          d="M0,40 L0,20 Q360,0 720,20 Q1080,40 1440,15 L1440,40 Z"
          fill="#0D1B3E"
        />
      </svg>
    </div>

    <div className="section-inner grid-footer-4">
      <div>
        <BrandLogo showTagline asLink={false} size="sm" className="[&_.brand-wordmark]:text-white [&_span]:text-[#E8651A]" />
        <p className="text-white/65 text-sm mt-4 leading-relaxed">
          Atithi Travel &amp; Taxi Service — Rajkot&apos;s trusted cab partner for pan-India outstation, airport and local travel.
        </p>
      </div>
      <div>
        <h4 className="text-[#E8651A] font-bold text-sm uppercase mb-4 tracking-wide">Quick Links</h4>
        <ul className="space-y-2 text-sm text-white/75">
          <li><Link to="/" className="hover:text-[#E8651A]">Home</Link></li>
          <li><Link to="/book-vehicle" className="hover:text-[#E8651A]">Book a Cab</Link></li>
          <li><a href="/#fleet" className="hover:text-[#E8651A]">Our Fleet</a></li>
        </ul>
      </div>
      <div>
        <h4 className="text-[#E8651A] font-bold text-sm uppercase mb-4 tracking-wide">Our Services</h4>
        <ul className="space-y-2 text-sm text-white/75">
          <li><Link to="/book-vehicle?trip=airport_transfer" className="hover:text-[#E8651A]">Airport Pick-up &amp; Drop</Link></li>
          <li><Link to="/book-vehicle?trip=round_trip" className="hover:text-[#E8651A]">Outstation Trips</Link></li>
          <li><Link to="/book-vehicle?trip=local_rental" className="hover:text-[#E8651A]">Local Taxi</Link></li>
          <li><Link to="/book-vehicle?trip=one_way" className="hover:text-[#E8651A]">One-Way Taxi</Link></li>
          <li><Link to="/book-vehicle?trip=one_way" className="hover:text-[#E8651A]">Corporate Travel</Link></li>
          <li><Link to="/book-vehicle?trip=round_trip" className="hover:text-[#E8651A]">Round Trip Cab</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="text-[#E8651A] font-bold text-sm uppercase mb-4 tracking-wide">Contact</h4>
        <ul className="space-y-3 text-sm text-white/75">
          <li className="flex gap-2"><MapPin size={16} className="text-[#E8651A] shrink-0 mt-0.5" />{BRAND.contact.address}</li>
          <li><a href={`tel:${BRAND.contact.phone}`} className="flex items-center gap-2 hover:text-[#E8651A]"><Phone size={16} className="text-[#E8651A]" />{BRAND.contact.phoneDisplay}</a></li>
          <li><a href={`mailto:${BRAND.contact.email}`} className="flex items-center gap-2 hover:text-[#E8651A]"><Mail size={16} className="text-[#E8651A]" />{BRAND.contact.email}</a></li>
          <li className="flex items-center gap-2"><Clock size={16} className="text-[#E8651A]" />24/7 · Mon – Sun</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10 py-4 text-center text-white/45 text-sm w-full">
      © 2026 Atithi Travel &amp; Taxi Service · Rajkot, Gujarat · Pan-India Service
    </div>
  </footer>
);

export default AtithiFooter;
